import requst from "./request";

// 非登录状态下获取栏目信息
export const getNotLogIn = (data) =>
  requst.get("/cmsapi/getNotLogIn", { ...data });

// 登录状态下获取栏目信息
export const getIndexNews = (data) =>
  requst.post("/cmsapi/getIndexNews", {
    ...data,
  });
